var tOutID;

window.deskSubMenu = function (){
	$('#hdr_main_nav > ul > li:has(.submenu)').mouseover(function(){
		if($(window).width() > "850"){
			var trigElmntID = $(this).attr("data-nav-el");
			$('#hdr_main_nav > ul > li > .submenu').not($(this).children('.submenu')).slideUp(300);
			$(this).children('.submenu').slideDown(500);
			clearTimeout(tOutID);
			delayedSlideUp(trigElmntID);
		}
	});
}
	

function delayedSlideUp(trigElmntID){
	 tOutID = setTimeout(function(){
	$('#'+trigElmntID).nextAll().slideUp(300);
	},3000);
}